<template>
  <esg-base-chart max-width="500px">
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart id="firmwide-emissions-by-scope-for-three-years"
                type="bar"
                ref="chart"
                :width=this.width
                :height=this.height
                v-show="!loading"
                :options="chartOptions"
                :series="series"/>
  </esg-base-chart>
</template>
<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  components: { EsgBaseChart },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '250'
    },
    legend: {
      type: String,
      default: 'right'
    }
  },
  data() {
    return {
      loading: false,
      series: [],
      chartOptions: {
        chart: {
          type: "bar",
          stacked: true,
          fontFamily: 'NanumGothic',
          toolbar: { show: false },
          zoom: { enabled: false }
        },
        plotOptions: {
          bar: {
            colors: {
              backgroundBarOpacity: .1
            },
            dataLabels: {
              total: {
                enabled: true,
                formatter: val => this.formatNumber(val, 0),
                style: {
                  fontWeight: 'normal',
                  colors: ['#000']
                },
              }
            }
          },
        },
        xaxis: {
          categories: [],
          crosshairs: { show: false }
        },
        yaxis: {
          show: true,
          title: {
            text: '탄소 배출량 (tCO2)',
            style: {
              fontSize: '12px',
              fontWeight: 'normal',
            },
          },
          labels: {
            formatter: val => this.compactFormatNumber(val)
          },
          crosshair: { show: false }
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          y: {
            formatter: val => this.formatNumber(val) + ' tCO2'
          }
        },
        grid: {
          show: false
        },
        legend: {
          position: this.legend,
        },
        responsive: []
      },
    }
  },
  created() {
    this.fetchData();
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        let year = new Date().getFullYear();
        let years = [year - 2, year - 1, year];
        let scopes = [1, 2, 3];
        let args = [{
          years,
          scopes,
          groupKeys: ['year', 'scope']
        }];

        let data = new FormData()
        data.append('path', 'esg/ghg_emission/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });


        if (!response.data.data) {
          this.series = [];
          return
        }
        let list = JSON.parse(response.data.data)[0].data;

        this.setSeries(list, scopes, years);
        this.setLabels(years);
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
        this.refreshChart();
      }
    },
    setSeries(list, scopes, years) {
      scopes.forEach(scope => {
        let data = [];
        years.forEach(year => {
          let row = list.find(row => row.scope === scope && row.year === year);
          data.push(row ? row.values : 0)
        });
        this.series.push({
          name: 'Scope ' + scope,
          data: data
        })
      })
    },
    setLabels(years) {
      this.chartOptions.xaxis.categories = years;
    },
  }
}
</script>

<style scoped>
>>> #firmwide-emissions-by-scope-for-three-years .apexcharts-bar-area[j="0"],
>>> #firmwide-emissions-by-scope-for-three-years .apexcharts-bar-area[j="1"] {
  opacity: .5;
}
</style>